import { render } from "./SortDropdown.vue?vue&type=template&id=d33837d8&ts=true"
import script from "./SortDropdown.vue?vue&type=script&lang=ts"
export * from "./SortDropdown.vue?vue&type=script&lang=ts"

import "./SortDropdown.vue?vue&type=style&index=0&id=d33837d8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__